"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripeMetadata = exports.Product = exports.Price = exports.InstallmentPrice = exports.SpecialOfferings = exports.SpecialOfferingsByEmail = exports.Offering = exports.OfferingAccess = exports.OfferingAccessGroup = exports.OffersModel = exports.Offer = exports.MoneyModel = exports.InstallmentBreakdown = exports.GetOffersDto = exports.Coupon = exports.PlatformEnum = exports.PeriodEnum = exports.OfferingType = exports.AccessTypeEnum = exports.SupportedCurrency = void 0;
var SupportedCurrency;
(function (SupportedCurrency) {
    SupportedCurrency["USD"] = "USD";
    SupportedCurrency["BRL"] = "BRL";
    SupportedCurrency["CAD"] = "CAD";
})(SupportedCurrency = exports.SupportedCurrency || (exports.SupportedCurrency = {}));
var AccessTypeEnum;
(function (AccessTypeEnum) {
    AccessTypeEnum["Allow"] = "allow";
    AccessTypeEnum["Block"] = "block";
})(AccessTypeEnum = exports.AccessTypeEnum || (exports.AccessTypeEnum = {}));
var OfferingType;
(function (OfferingType) {
    OfferingType["Stripe"] = "stripe";
    OfferingType["Roku"] = "roku";
    OfferingType["Itunes"] = "itunes";
    OfferingType["Ppv"] = "ppv";
    OfferingType["StripeInstallment"] = "stripe_installment";
})(OfferingType = exports.OfferingType || (exports.OfferingType = {}));
var PeriodEnum;
(function (PeriodEnum) {
    PeriodEnum["Year"] = "year";
    PeriodEnum["Month"] = "month";
    PeriodEnum["Once"] = "once";
    PeriodEnum["Seasonal"] = "seasonal";
})(PeriodEnum = exports.PeriodEnum || (exports.PeriodEnum = {}));
var PlatformEnum;
(function (PlatformEnum) {
    PlatformEnum["Stripe"] = "stripe";
    PlatformEnum["FloSports"] = "FloSports";
    PlatformEnum["Itunes"] = "itunes";
    PlatformEnum["Roku"] = "roku";
    PlatformEnum["External"] = "external";
})(PlatformEnum = exports.PlatformEnum || (exports.PlatformEnum = {}));
class Coupon {
}
exports.Coupon = Coupon;
class GetOffersDto {
}
exports.GetOffersDto = GetOffersDto;
class InstallmentBreakdown {
}
exports.InstallmentBreakdown = InstallmentBreakdown;
class MoneyModel {
}
exports.MoneyModel = MoneyModel;
class Offer {
}
exports.Offer = Offer;
class OffersModel {
}
exports.OffersModel = OffersModel;
class OfferingAccessGroup {
}
exports.OfferingAccessGroup = OfferingAccessGroup;
class OfferingAccess {
}
exports.OfferingAccess = OfferingAccess;
class Offering {
    constructor() {
        this.active = true;
        this.show = false;
    }
}
exports.Offering = Offering;
class SpecialOfferingsByEmail {
}
exports.SpecialOfferingsByEmail = SpecialOfferingsByEmail;
class SpecialOfferings {
}
exports.SpecialOfferings = SpecialOfferings;
class InstallmentPrice extends Offering {
}
exports.InstallmentPrice = InstallmentPrice;
class Price extends Offering {
}
exports.Price = Price;
class Product {
    constructor() {
        this.active = true;
    }
}
exports.Product = Product;
class StripeMetadata {
}
exports.StripeMetadata = StripeMetadata;
